export default function NotFound() {
  return (
    <main style={{ padding: "1rem", color: 'red', fontWeight: 'bold' }}>
      <p>Page is moved to a different link or it is yet to be published</p>
    </main>
  );
}
